import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { useCookies } from 'react-cookie';
import style from './style.module.scss';

const CookieBanner: React.FC = () => {
  const [cookies, setCookie] = useCookies(['cookies-accepted']);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!cookies['cookies-accepted']) {
      setIsVisible(true);
    }
  }, [cookies]);

  const handleAccept = () => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    setCookie('cookies-accepted', 'true', {
      path: '/',
      expires: expirationDate,
    });
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Paper elevation={3} className={style.banner}>
      <Box className={style.content}>
        <Typography variant="body2" className={style.text}>
          We use cookies to ensure you get the best experience on our website.
        </Typography>
        <Button
          variant="contained"
          size="small"
          onClick={handleAccept}
          className={style.button}
        >
          Got it!
        </Button>
      </Box>
    </Paper>
  );
};

export default CookieBanner;
